import { render } from "./RankingScreen.vue?vue&type=template&id=07cda03a&scoped=true"
import script from "./RankingScreen.vue?vue&type=script&lang=js"
export * from "./RankingScreen.vue?vue&type=script&lang=js"

import "./RankingScreen.vue?vue&type=style&index=0&id=07cda03a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cda03a"]])

export default __exports__